var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-form-group", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var ariaDescribedby = ref.ariaDescribedby
          return [
            _c("b-form-radio-group", {
              attrs: {
                options: _vm.optionsSettledLabels,
                "aria-describedby": ariaDescribedby,
                size: "lg",
                state: _vm.state,
                stacked: _vm.stacked,
                "text-field": "label"
              },
              on: {
                change: function($event) {
                  return _vm.$emit("change", $event)
                }
              },
              model: {
                value: _vm.localValue,
                callback: function($$v) {
                  _vm.localValue = $$v
                },
                expression: "localValue"
              }
            }),
            _vm._v(" "),
            _c("b-form-invalid-feedback", { attrs: { state: _vm.state } }, [
              _vm._v(_vm._s(_vm.errorMsg))
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6efd13da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6efd13da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/forms/BaseRadioGroup.vue
// module id = 1644
// module chunks = 116